import $ from 'jquery'

function _NikanUI() {

}

_NikanUI.prototype.init = function () {
  this.layoutSections()
  this.fullHouseHeight()
}

_NikanUI.prototype.layoutSections = function () {
  function initUI() {
    var box = $('.white-box')
    var offset = box.offset()
    var marginTop = parseFloat(box.css('margin-top'))

    var container = $('.container-fluid')
    var containerPadding = parseFloat(container.css('padding-top')) + parseFloat(container.css('padding-bottom'))

    var diff = offset.top + marginTop + containerPadding * 2
    var height = parseFloat($(window).height()) - diff - 5
    box.height(height)

    var content = $('.white-content')
    content.slimScroll({
      height: '100%',
      position: 'right',
      size: '5px',
      color: '#dcdcdc'
    })

    $('.slimScrollBar').hide()
  }

  initUI()
  $(window).resize(initUI)
}

_NikanUI.prototype.scrollable = function (jel, options) {
  function act() {
    //   jel.slimScroll(options);
  }

  act()
  jel.resize(act)
}

_NikanUI.prototype.fullHouseHeight = function () {
  var els = $('.full-house-height')
  $.each(els, function (index, item) {
    var parentSelector = $(item).attr('fhh-parent')
    var parent = $(item).parent()
    if (parentSelector) {
      parent = $(item).parents(parentSelector)
    }

    var parentHeight = parent.height()

    var detailsHeightSelector = $(item).attr('fhh-details')
    if (detailsHeightSelector) {
      parentHeight -= $(detailsHeightSelector).height()
    }

    var padding = parseFloat(parent.css('padding-top')) + parseFloat(parent.css('padding-bottom'))
    parentHeight -= padding

    $(item).height(parentHeight)
  })
}

const NikanUI = {
  install(app) {
    const ui = new _NikanUI()
    app.$ui = ui
    app.config.globalProperties.$wait = ui
  }
}

export default NikanUI
